<template>
  <div class="animated fadeIn">
    <div class="page-header d-flex">
      <h4 class="page-title">
        <i class="fas fa-list-alt"></i>
        Check User Pattern
      </h4>
      <ul class="breadcrumbs ml-auto">
        <li class="nav-home mr-1">
          <a href="#">
            <i class="fas fa-home text-muted"></i>
          </a>
        </li>
        <li class="nav-item">
          <a class="font_15" href="#">WMDS</a>
        </li>
        <li class="separator">
          <i class="flaticon-right-arrow"></i>
        </li>
        <li class="nav-item">
          <a class="font_15 font-weight-bold" href="#">U.Pattern</a>
        </li>
      </ul>
    </div>
    <b-row>
      <b-col lg="12" xl="12">
        <b-card>
          <div class="d-flex flex-wrap align-items-center">
            <div class="title mr-auto mb7">
              Pattern
              <br>
              <span class="font-weight-light font_13"> Set the user pattern to be added to the scan user's site.</span>
            </div>
            <div class="mb7">
              <span class="float-right">{{model.created_at | datetime}}</span>
            </div>
          </div>
          <hr>
          <b-row class="mb-2">
            <b-col class="col-xl-2 col-md-12 d-flex align-self-center">
              <label class="col-form-label" for="is_use_true">
                Status
              </label>
            </b-col>
            <b-col class="col-xl-4 col-md-12  d-flex align-self-center">
              <div class="checkbox-switch">
                <input type="checkbox" class="input-checkbox" name="Allow_login" id="Allow_login" v-model="model.is_alive" :disabled="lock">
                <div class="checkbox-animate disabled">
                  <span class="checkbox-off">OFF</span>
                  <span class="checkbox-on">ON</span>
                </div>
              </div>
            </b-col>
          </b-row>
          <b-row class="mb-2">
            <b-col class="col-xl-2 col-md-12 d-flex align-self-center">
              <label class="col-form-label" for="ph_level" v-b-tooltip.hover title="Sets the risk level for the pattern.">Level</label>
            </b-col>
            <b-col class="col-xl-4 col-md-12">
              <b-form-select class="form-control" d="ph_level" v-model="model.level" :disabled="lock">
                <option value="H">Danger</option>
                <option value="W">Warning</option>
                <option value="N">Caution</option>
                <option value="S">Suspicion</option>
              </b-form-select>
            </b-col>
          </b-row>
          <b-row>
            <b-col class="col-xl-2 col-md-12 d-flex align-self-center">
              <label class="col-form-label" for="ph_type" v-b-tooltip.hover title="It's how the pattern works. URL (Link retention investigation), String (Inclusion of strings), Regex (Scan content with regular expression), MD5 (Comparison of MD5 hash values for content)">Type</label>
            </b-col>
            <b-col class="col-xl-4 col-md-12">
              <b-form-select class="form-control" id="ph_type" v-model="model.type" :disabled="lock">
                <option value="U">URL</option>
                <option value="S">String</option>
                <option value="R">Regex</option>
                <option value="M">MD5</option>
              </b-form-select>
            </b-col>
          </b-row>
          <b-row class="mb-4 mt-2">
            <b-col class="col-xl-2 col-md-12 d-flex align-self-center">
              <label class="col-form-label" for="ph_code" v-b-tooltip.hover title="Code to be retrieved from the page.">Code</label>
            </b-col>
            <b-col class="col-xl-4 col-md-12">
              <b-form-input :state="model.type == 'R' ? regex_valid(model.code) : (model.code && model.code.length > 0) || false" md=5 type="text" id="ph_code" v-model="model.code" :plaintext="lock"></b-form-input>
            </b-col>
          </b-row>
          <template v-if="lock">
            <b-button size="sm" variant="warning" @click="edit" :disabled="model.is_del"> Edit </b-button>
            <b-button size="sm" variant="danger" @click="confirm = true" :disabled="model.is_del"> Remove </b-button>
          </template>
          <template v-else>
            <b-button size="sm" class="btn btn-add" @click="save"> Save </b-button>
            <b-button size="sm" variant="secondary" @click="cancel"> Cancel </b-button>
          </template>
          <b-button size="sm" class="float-right" variant="primary" @click="list"> List </b-button>
        </b-card>
      </b-col>
    </b-row>

    <b-modal title="Pattern Remove" class="modal-danger" v-model="confirm" @ok="remove" ok-variant="outline-danger" cancel-variant="outline-dark" header-bg-variant="danger">
      This operation cannot be reversed.
    </b-modal>
  </div>
</template>

<script>
  import App from './app.js'; export default Object.assign({}, App);
</script>